module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_SK-91a584294190f5b3d75f57c5e4f280f7.svg";